import { Component, inject, Input, isDevMode, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { DxPopupComponent } from 'devextreme-angular';
import { DxTemplateDirective } from 'devextreme-angular/core';
import { JsonviewerComponent } from '../jsonviewer/jsonviewer.component';

@Component({
  selector: 'app-debug-info',
  templateUrl: './debug-info.component.html',
  styleUrls: ['./debug-info.component.scss'],
  imports: [DxPopupComponent, DxTemplateDirective, JsonviewerComponent]
})
export class DebugInfoComponent implements OnDestroy {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  @Input() debugVisible = false;
  debugInfo: Record<string, unknown>[] = null;

  #destroyable$ = new Subject<void>();
  #subscription$: Subscription;

  constructor() {
    if (isDevMode()) {
      this.#subscription$ = this.router.events
        .pipe(
          filter(event => event instanceof NavigationEnd),
          takeUntil(this.#destroyable$)
        )
        .subscribe({
          next: () => {
            const route = this.activatedRoute.root;
            this.debugInfo = this.getComponentInfo(route);
          }
        });
    }
  }

  getComponentInfo(route: ActivatedRoute, debugInfo: Record<string, unknown>[] = []): Record<string, unknown>[] {
    const children: ActivatedRoute[] = route.children;

    // iterate over each child
    for (const child of children) {
      if (child.routeConfig && child.routeConfig.component) {
        const component = child.routeConfig.component;
        const keys = Object.keys(component.prototype as Record<string, unknown>);
        debugInfo.push({
          component: component.name,
          functions: keys
        });
      }

      this.getComponentInfo(child, debugInfo);
    }

    return debugInfo;
  }

  ngOnDestroy(): void {
    if (this.#subscription$) {
      this.#subscription$.unsubscribe();
    }
    this.#destroyable$.next();
    this.#destroyable$.complete();
  }
}
